import { render, staticRenderFns } from "./OverlayLoader.vue?vue&type=template&id=e1b79f46&"
import script from "./OverlayLoader.vue?vue&type=script&lang=js&"
export * from "./OverlayLoader.vue?vue&type=script&lang=js&"
import style0 from "./OverlayLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports